import { formatDuration } from "./format";
import { SURFACE_LABEL, type ScreenTimeRow, type Surface } from "./types";
import { Bar, Card } from "./ui";

export function ScreenTimeSection({ rows, loading }: { rows: ScreenTimeRow[]; loading: boolean }) {
  const max = rows.reduce((m, r) => Math.max(m, r.total_ms), 0);
  return (
    <section className="space-y-4">
      <p className="cs-caption">Schermtijd</p>
      <div className="grid gap-4 md:grid-cols-2">
        {(["widget", "mobile"] as Surface[]).map((surface) => {
          const own = rows.filter((r) => r.surface === surface);
          return (
            <Card key={surface} caption={SURFACE_LABEL[surface]}>
              {own.length === 0 ? (
                <p className="text-sm text-[var(--cs-ink-muted)]">{loading ? "Laden…" : "Nog geen telemetrie in deze periode"}</p>
              ) : (
                <table className="w-full text-sm">
                  <thead>
                    <tr className="text-left text-xs uppercase tracking-wide text-[var(--cs-ink-muted)]">
                      <th className="py-1">Scherm</th>
                      <th className="py-1 text-right">Weergaven</th>
                      <th className="py-1 text-right">Mediaan</th>
                      <th className="py-1 text-right">Totaal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {own.map((r) => (
                      <tr key={r.screen} className="border-t border-[rgba(10,52,96,0.06)]">
                        <td className="py-2">
                          <div className="text-[var(--cs-navy)]">{r.screen}</div>
                          <Bar value={r.total_ms} max={max} />
                        </td>
                        <td className="py-2 text-right tabular-nums">{r.views}</td>
                        <td className="py-2 text-right tabular-nums">{formatDuration(r.median_ms)}</td>
                        <td className="py-2 text-right tabular-nums">{formatDuration(r.total_ms)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </Card>
          );
        })}
      </div>
    </section>
  );
}
